import { errorTextStyles, helperTextStyles } from './form-field-styles'

/**
 * Error (preferred) or helper line under a field, with the ids `fieldDescribedBy`
 * links: `${fieldId}-error` / `${fieldId}-helper`.
 */
export function FieldMessages({ fieldId, error, helperText }: { fieldId: string; error?: string; helperText?: string }) {
  if (error) {
    return (
      <p id={`${fieldId}-error`} className={errorTextStyles} role="alert">
        {error}
      </p>
    )
  }
  if (helperText) {
    return (
      <p id={`${fieldId}-helper`} className={helperTextStyles}>
        {helperText}
      </p>
    )
  }
  return null
}
